module.exports = __webpack_public_path__ + "static/seniorDev-216ad066d7efa7ce13968f73556f5493.png";